(function(){
  'use strict';
  var backdrop;
  function getCart(){ return document.getElementById('mini-cart'); }
  function ensureBackdrop(){
    backdrop=document.querySelector('.smart-cart-backdrop');
    if(!backdrop){
      backdrop=document.createElement('div');
      backdrop.className='smart-cart-backdrop';
      backdrop.setAttribute('aria-hidden','true');
      var cart=getCart();
      if(cart && cart.parentNode){
        cart.parentNode.insertBefore(backdrop, cart);
      } else {
        document.body.appendChild(backdrop);
      }
    }
    return backdrop;
  }
  function toggleFromHeader(){
    var toggle=document.querySelector('[aria-controls="mini-cart"][data-action="toggle-mini-cart"], [aria-controls="mini-cart"]');
    if(toggle) toggle.click();
  }
  function sync(){
    var cart=getCart(), layer=ensureBackdrop();
    var open=!!cart && cart.getAttribute('aria-hidden')==='false';
    layer.classList.toggle('is-visible',open);
    layer.setAttribute('aria-hidden',open?'false':'true');
    document.documentElement.classList.toggle('smart-cart-is-open',open);
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-smart-cart-close]')){ e.preventDefault(); toggleFromHeader(); }
    if(e.target.classList && e.target.classList.contains('smart-cart-backdrop')){ e.preventDefault(); toggleFromHeader(); }
  });
  function observe(){
    var cart=getCart(); if(!cart) return;
    new MutationObserver(sync).observe(cart,{attributes:true,attributeFilter:['aria-hidden']});
    sync();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',observe); else observe();
  document.addEventListener('cart:rerendered',sync);
})();
